<template>
  <img
    v-if="src"
    ref="imageElement"
    class="absolute inset-0 h-full object-cover transition group-hover:scale-105"
    loading="lazy"
    :srcset
    :src
    :sizes
    :width
    :height
  />

  <span
    v-else
    class="absolute inset-0 grid h-full place-items-center rounded-md border text-xs font-bold text-gray-300"
  >
    <span class="flex flex-col">
      <Icon
        icon="image-landscape"
        class="text-3xl"
      />
      <span class="mt-1">IMAGE PENDING</span>
    </span>
  </span>
</template>

<script setup lang="ts">
const props = defineProps<{
  srcset?: string
  src?: string
  width?: number
  height?: number
}>()

const imageElement = ref<HTMLImageElement | null>(null)

const sizes = ref('1px')

onMounted(() => {
  if (!imageElement.value) return

  const { width: size } = imageElement.value.getBoundingClientRect()
  sizes.value = Math.ceil((size / window.innerWidth) * 100) + 'vw'
})
</script>
